/*
 * @Description: 可拖拽表格
 * @Author: 杨志航
 * @Date: 2026-09-06 09:39:21
 */
import React, { useRef } from 'react'
import { Table } from 'antd'
import { DndProvider, useDrag, useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import './style.scss'

const type = 'DraggableBodyRow'

const DraggableBodyRow = ({ index, moveRow, className, style, ...restProps }) => {
  const ref = useRef(null)
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {}
      if (dragIndex === index) {
        return {}
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      }
    },
    drop: (item) => {
      moveRow(item.index, index)
    },
  })
  const [, drag] = useDrag({
    type,
    item: {
      index,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  drop(drag(ref))

  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{
        cursor: 'move',
        ...style,
      }}
      {...restProps}
    />
  )
}

const DraggableTable = ({
  columns,
  dataSource,
  moveRow,
  onRow,
  rowKey = (_, index) => index,
  ...restProps
}) => {
  const components = {
    body: {
      row: props => <DraggableBodyRow {...props} moveRow={moveRow} />,
    },
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <Table
        className="draggable-table"
        rowKey={rowKey}
        columns={columns}
        dataSource={dataSource}
        components={components}
        onRow={(_, index) => {
          const rowProps = onRow ? onRow(_, index) : {}
          return {
            ...rowProps,
            index,
            moveRow,
          }
        }}
        {...restProps}
      />
    </DndProvider>
  )
}

export default DraggableTable
